import React, { Component } from 'react';
import { SemVer, rcompare, parse } from "semver";
import { makeCdnUrl } from 'motion-master-client';

import { brandId } from "./brand";
import FirmwareBundlesButtons from "./FirmwareBundlesButtons";

class FirmwareList extends Component {
  constructor(props) {
    super(props);

    const allVersions = props.firmwares.sort(rcompare);
    const release = props.release;
    const allReleases = props.allReleases;

    this.state = {
      release,
      allReleases,
      allVersions,
      filteredVersions: [],
      isFiltered: true,
    };

    this.filterLatestMinorVersions = this.filterLatestMinorVersions.bind(this);
  }

  componentDidMount() {
    this.setState({
      filteredVersions: this.filterLatestMinorVersions(),
    });
  }

  filterLatestMinorVersions() {
    const latestMinorVersionsMap = new Map();

    for (const item of this.state.allVersions) {
      const version = parse(item);
      const baseVersion = new SemVer(
        `${version.major}.${version.minor}.0`
      ).toString();

      if (!latestMinorVersionsMap.has(baseVersion)) {
        latestMinorVersionsMap.set(baseVersion, version);
      }

      const maxVersion = latestMinorVersionsMap.get(baseVersion);
      const cc = maxVersion.compare(version);
      if (cc < 0) {
        latestMinorVersionsMap.set(baseVersion, version);
      }
    }

    const latestMinorVersions = Array.from(latestMinorVersionsMap.values()).map(
      (v) => `v${v.toString()}`
    );

    // Filter all packages that contain the latest version
    return this.state.allVersions.filter((version) =>
      latestMinorVersions.includes(version)
    );
  }

  render() {
    return (
      <ul className="l-none list-inline">
        {(this.state.isFiltered
          ? this.state.filteredVersions
          : this.state.allVersions
        ).map((v, i) => {
          const link = makeCdnUrl(
            `/brands/${brandId}/bundles/firmwares/somanet-motion-drive_${encodeURIComponent(
              v
            )}.odbx`
          );
          return (
            <li className="list-inline-item mb-2" key={v + i}>
              <span className="btn-group rounded">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary px-2 dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {v}&nbsp;
                </button>
                <div className="dropdown-menu shadow">
                  <h6 className="dropdown-header text-uppercase">Firmware</h6>
                  <FirmwareBundlesButtons
                    oblacDrivesVersion={this.props.release.version}
                    releases={this.props.allReleases}
                    firmwareVersion={v}
                  />
                  <div className="dropdown-divider"></div>
                  <h6 className="dropdown-header text-uppercase">Download</h6>
                  <a href={link} className="dropdown-item">
                    Firmware Bundle (.odbx)
                  </a>
                </div>
              </span>
            </li>
          );
        })}
        <li className="list-inline-item mb-2">
          <button
            type="button"
            className="btn btn-link"
            onClick={() =>
              this.setState({ isFiltered: !this.state.isFiltered })
            }
          >
            {this.state.isFiltered
              ? "Show all versions"
              : "Hide old patch versions"}
          </button>
        </li>
      </ul>
    );
  }
}

export default FirmwareList;
